/*
  Rated_v2.js propTypes
  extracted from https://bully---varnish.ref-sa-tech.io/documentation/resources/oaspec.json
  on 2019-04-15T15:32:06.065Z
*/

import { number } from 'prop-types'

const Rated_v2 = {
  one: number,
  two: number,
  three: number,
  four: number,
  five: number,
}

export default Rated_v2
